import { _, Backbone, moment, Radio, Foundation, $ } from "../../../vendor";
import { Backform, Biscuit } from "../../utils";
import InboomaBaseView from "../InboomaBaseView";
import { appRollingLoaderAnim } from "../AppAnnouncements";
import "../../../vendor/Blob";
import { getApiHost } from "../../Sync";
import * as FileSaver from "../../../vendor/FileSaver";

import VouchersExportTpl from "../../templates/vouchers/VouchersExportTpl.html";

export default InboomaBaseView.extend({
  el: "#vouchers-export-form",
  template: VouchersExportTpl,

  ui: {
    formErrorDiv: ".off-canvas__form-error",
  },

  initialize() {
    this.render();
  },

  onRender() {
    const that = this,
      formErrorDiv = this.getUI("formErrorDiv");

    const model = new Backbone.Model({
      type: "normal", // not used as of now
      voucher: null,
    });
    let vouchersA = that.model.attributes.vouchers;
    let vouchers = [];
    /* const VouchersRequest = Backbone.Model.extend({
             urlRoot: '/vouchers?voucher_type_id=' + voucher_type_id
         });
         let vouchers = [];
         const clientSettingsRequest = (new ClientSettingsRequest()).fetch({
             success(model, response) {
                 $.each(response.data, function(_field,key){
                     vouchers.push({ label: key.voucher_code, value: voucher.id});

                 });

             }
         });*/
    /* let options = [];*/

    _.map(vouchersA, (location) => {
      vouchers.push({ label: location.voucher_code, value: location.id });
    });

    const fields = [
      /*{
                name: "type",
                label: this.t('rental_contract_type'),
                control: "select",
                options: [
                    { label: this.t('rental_contract_type_normal'), value: 'normal' },
                    { label: this.t('rental_contract_type_slowup'), value: 'slowup' }
                ],
                size: {
                    "large" : "3"
                }
            },*/
      {
        // @todo If not all locations are shown, change control to
        // inboomaselect, as done at same place
        // in OrdersSalesBillingsView.js
        name: "voucher",
        label: this.t("Voucher", null, "capital"),
        control: "selector",
        required: true,
        forceFirstSelected: true,
        options: vouchers,
        size: {
          large: "6",
        },
      },
      {
        label: this.t("generate", null, "capital"),
        control: "button",
        extraClasses: ["button-submit"],
      },
    ];

    const form = new Backform.Form({
      el: that.$el.find("form"),
      model,
      fields,
      events: {
        "click .button-submit"(ev) {
          ev.preventDefault();

          formErrorDiv.addClass("hide");

          that.$el.find(".button-submit").prepend(appRollingLoaderAnim);

          const xmlHttp = new XMLHttpRequest();

          xmlHttp.open(
            "GET",
            getApiHost() + "/vouchers/getQRCode/" + model.get("voucher") /*+ slowup*/,
            true,
          );

          xmlHttp.setRequestHeader("Accept", "image/png");
          xmlHttp.setRequestHeader("Authorization", "Bearer " + Biscuit.get("token"));
          xmlHttp.responseType = "blob";

          xmlHttp.onload = function () {
            that.$(".button-submit img").remove();

            if (xmlHttp.status === 500 || xmlHttp.status === 400) {
              formErrorDiv.html("rental_contract_error").removeClass("hide");
              return;
            }

            if (
              xmlHttp.status === 404 ||
              (typeof xmlHttp.response.size !== "undefined" && xmlHttp.response.size === 1229)
            ) {
              formErrorDiv.html(that.t("rental_contract_error_empty")).removeClass("hide");
              return;
            }

            const blob = new Blob([xmlHttp.response], { type: "image/png" });
            let voucher = Radio.channel("vouchers").request("get:data").get(model.get("voucher"));
            FileSaver.saveAs(blob, voucher.get("voucher_code") + ".png");
          };

          xmlHttp.send(null);
        },
      },
    }).render();

    this.modal = new Foundation.Reveal(this.$el);

    this.modal.open();

    this.$el.on("closed.zf.reveal", () => {
      Radio.channel("app").trigger("destroy:backform"); // Remove pikaday from DOM

      that.$el.foundation("_destroy");

      that.unbind();
      that.undelegateEvents();
      that.unbindEvents();
      that.unbindUIElements();

      Backbone.history.navigate("vouchers/" + that.model.attributes.id, {
        trigger: true,
      });
      that.$el.off("closed.zf.reveal");
    });
  },
});
